import tmhRequest from '@/config/tmhRequest'

export default {
    searchCommentReportCount: function (data) {
        return tmhRequest({
            url: '/report/ispa/commentreport/searchcommentreportcount',
            method: 'post',
            data: data,
        })
    },
    searchCommentReportByPage: function (data) {
        return tmhRequest({
            url: '/report/ispa/commentreport/searchcommentreportbypage',
            method: 'post',
            data: data,
        })
    },
    exportCommentReport: function (data) {
        return tmhRequest({
            url: '/report/ispa/commentreport/exportcommentreport',
            method: 'post',
            responseType: 'blob',
            data: data,
        })
    },
}


// WEBPACK FOOTER //
// ./src/api/ispa/report/commentreport.js